import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { isEqual } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { TrackingPageCoreService } from '../../tracking-page-core.service';
import { TrackingPageModel } from '../../tracking-page.model';

@Component({
  selector: 'app-tracking-page-search',
  templateUrl: './tracking-page-search.component.html',
  styleUrls: ['./tracking-page-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrackingPageSearchComponent implements OnInit {
  @Input() trackingPage: TrackingPageModel;
  @Input() noNumbers: string | boolean;
  @Input() mode: any;
  @Input() selectedVisualBuilderId: any;
  @Input() isVisualBuilder: boolean;
  @Output() triggerSearchNumber = new EventEmitter();
  @Output() triggerBackToSearch = new EventEmitter();
  @Output() selectBlock = new EventEmitter();
  @Output() changeLanguage = new EventEmitter();

  @ViewChild('checkingSection', { read: ElementRef })
  checkingSection: ElementRef;
  @ViewChild('innerCheckingSection', { read: ElementRef })
  innerCheckingSection: ElementRef;
  @ViewChild('container', { read: ElementRef })
  container: ElementRef;
  @ViewChild('companyForm', { read: ElementRef })
  companyForm: ElementRef;
  @ViewChild('row', { read: ElementRef }) row: ElementRef;

  readonly noNumber$ = new BehaviorSubject(false);

  constructor(private trackingPageCoreService: TrackingPageCoreService) {}

  ngOnInit() {}

  get backgroundStyles() {
    return this.trackingPageCoreService.getTrackingPageBackground(
      this.trackingPage
    );
  }

  onSearchClick({ target }) {
    if (
      (this.checkingSection &&
        isEqual(this.checkingSection.nativeElement, target)) ||
      (this.innerCheckingSection &&
        isEqual(this.innerCheckingSection.nativeElement, target)) ||
      (this.container && isEqual(this.container.nativeElement, target)) ||
      (this.companyForm && isEqual(this.companyForm.nativeElement, target)) ||
      (this.row && isEqual(this.row.nativeElement, target))
    ) {
      this.selectBlock.emit('background');
    }
  }
}
